import { createConfirmation, confirmable } from 'react-confirm';
import Dialog, { OptionsProps } from './Dialog';

const DialogConfirmable = confirmable(Dialog);

const confirm = createConfirmation(DialogConfirmable);

const confirmWrapper = (confirmation: string, options: OptionsProps = { variant: 'primary', hideSecondaryBtn: false }) => confirm({ confirmation, options });

export {
  confirm,
  confirmWrapper,
};
